/* eslint-disable */

export enum SortByOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SortingField {
  BUSINESS_TOKEN = "BUSINESS_TOKEN",
  EXTERNAL_CREATED_AT = "EXTERNAL_CREATED_AT",
  RANKING_SCORES_POPULARITY = "RANKING_SCORES_POPULARITY",
  OFFER_START_TIME_MS = "OFFER_START_TIME_MS",
  OFFER_END_TIME_MS = "OFFER_END_TIME_MS",
  RANKING_SCORES_CATEGORY = "RANKING_SCORES_CATEGORY",
}

/** sort the results in ES query */
export interface SortBy {
  by_fields?: SortBySortByFields | undefined;
}

/** sort by any fields */
export interface SortBySortByFields {
  fields?: SortBySortByFieldsSortByField[];
  /** if set, will first sort by the relevancy score then use the specified fields to make the results stable */
  stable_sort?: boolean;
}

export interface SortBySortByFieldsSortByField {
  sorting_field?: SortingField;
  order?: SortByOrder;
}
